import { toPrivateBannerRawSchema, voBannersSchema, bannerListSchema, privateBannerSchema } from '../../models/banners/morph.js';
import { voBanners, bannerList, privateBanner } from '../../models/banners/zod.js';
import { voucherValidatedOrderSchema } from '../../models/promo/morph.js';
import { voucherValidatedOrder } from '../../models/promo/zod.js';
import { clientGet, clientPost, clientPut } from '../../utils/fetchwrapper.js';
import { processBody, returnStatus } from '../../utils/fetchwrapperUtils/responseProcessors.js';
import { morph } from '../../utils/fetchwrapperUtils/requestProcessors.js';

const getActiveVoBanners = (origin, entry_point, page, categories = []) => clientGet({
    url: `${origin}/v1/vouchers/banners`,
    queryParams: { entry_point, page, categories: categories.join(',') },
}).then(processBody(voBannersSchema, voBanners));
const validateVoucher = (origin, code, body, timeoutMs) => clientPost({
    url: `${origin}/v1/vouchers/validate/${code}`,
    timeoutMs,
}, body).then(processBody(voucherValidatedOrderSchema, voucherValidatedOrder));
const getBanners = (origin, queryParams) => clientGet({
    url: `${origin}/v1/private/vouchers/banners`,
    queryParams,
}).then(processBody(bannerListSchema, bannerList));
const createBanner = (origin, banner) => morph(banner, toPrivateBannerRawSchema)
    .then((morphedBody) => clientPost({
    url: `${origin}/v1/private/vouchers/banners`,
}, morphedBody))
    .then(processBody(privateBannerSchema, privateBanner));
const updateBanner = (origin, banner) => morph(banner, toPrivateBannerRawSchema)
    .then((morphedBody) => clientPut({
    url: `${origin}/v1/private/vouchers/banners/${banner.bannerId}`,
}, morphedBody))
    .then(processBody(privateBannerSchema, privateBanner));
const setBannerUsers = (origin, bannerId, users, timeoutMs) => clientPut({
    url: `${origin}/v1/private/vouchers/banners/${bannerId}/users`,
    timeoutMs,
}, { users }).then(returnStatus);

export { createBanner, getActiveVoBanners, getBanners, setBannerUsers, updateBanner, validateVoucher };
//# sourceMappingURL=client.js.map
